// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d0efec9b","455":"332064ec","977":"179a9349"}[chunkId] + ".chunk.js";
};